var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 90,
    viewBox: "0 0 88 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7639 76.3949C31.2852 71.8578 45.1847 74.4521 51.8445 89.3532C50.1502 89.6252 49.1686 87.6457 43.1403 88.4806C34.3735 90.4176 28.3934 88.2278 22.7639 76.3949Z",
    fill: "#726000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4425 50.5323C59.7351 41.8853 72.5506 35.911 86.6351 44.1585C85.4151 45.3652 83.4652 44.326 79.0472 48.5115C73.0426 55.1863 66.9044 56.8833 55.4425 50.5323Z",
    fill: "#726000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0403 59.7506C24.1473 52.2738 37.9699 49.2968 49.8694 60.4681C48.4117 61.3735 46.7415 59.927 41.5039 63.026C34.1661 68.1995 27.8043 68.49 18.0403 59.7506Z",
    fill: "#726000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9772 43.5768C27.5274 35.0625 40.5164 29.4756 54.347 38.1421C53.0914 39.3117 51.1736 38.2145 46.6319 42.2654C40.4297 48.757 34.2433 50.269 22.9772 43.5768Z",
    fill: "#726000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9387 26.5343C52.2237 17.8835 65.034 11.898 79.1257 20.1332C77.9067 21.341 75.9559 20.3036 71.5416 24.4928C65.5428 31.1729 59.4061 32.8753 47.9387 26.5343Z",
    fill: "#726000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1094 29.6791C21.6223 20.351 27.3003 7.40159 43.3232 4.29348C43.204 6.00529 41.0535 6.51265 40.5 12.5732C40.399 21.5509 36.9105 26.8788 24.1094 29.6791Z",
    fill: "#726000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0822 45.191C2.80292 40.2259 -2.13589 26.9769 7.20294 13.5911C8.30907 14.903 7.11849 16.7643 10.9403 21.5004C17.1177 28.0156 18.3224 34.269 11.0822 45.191Z",
    fill: "#726000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBrown);
export default __webpack_public_path__ + "static/media/logo-brown.1441ecad185d1da699bc32668c63ebc9.svg";
export { ForwardRef as ReactComponent };